import $ from 'jquery'; //global
import Threesixty from './threesixty';

import Form from './form';
import {navigation} from './navigation';
import {video_overlay} from './video-overlay';


let spin;

class Main{
    
    constructor()
    {
        //console.log("Main construct!");
    }
    
    init()
    {
        //set vars
        this.$window = $(window);
        this.contact_form = new Form('contact-form');

        this.setupContentFading();
        navigation.init();
        video_overlay.init();
        this.addListeners();
        this.resize();
    }

    setupContentFading()
    {
        $('.content-section:not(:first)').addClass('fade-in-element');
    }

    setupSpin() //called from navigation onScroll
    {
        //only once!
        if(spin)return;
        
        spin = $('.spin').ThreeSixty({
            totalFrames: 50, // Total no. of image you have for 360 slider
            endFrame: 50, // end frame for the auto spin animation
            currentFrame: 1, // This the start frame for auto spin
            imgList: '.threesixty_images', // selector for image list
            progress: '.spinner', // selector to show the loading progress
            imagePath:'images/360-spin/', // path of the image assets
            //filePrefix: 'ipod-', // file prefix if any 
            ext: '.jpg', // extention for the assets
            //height: 265,
            //width: 400,
            navigation: false,
            //disableSpin: true, // Default false
            responsive: true
        });
    }

    addListeners()
    {
        this.$window.on('resize', $.proxy(this.resize, this));
        this.$window.on('scroll', $.proxy(this.scroll, this));

    }

    resize(e)
    {
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = setTimeout(this.resizeComplete, 500);
    }

    resizeComplete()
    {
        navigation.resizeComplete();
    }

    scroll(e)
    {
        //handles sticky navigation,  navi-tem highlighting & content fading on scroll
        navigation.onScroll(e);
    }
}

//export only instance ( =  singleton like)
export let main_instance = new Main();

//doc ready -> init main
$(() => {main_instance.init()});


// WEBPACK FOOTER //
// ./src/script/main.js